module.exports = __webpack_public_path__ + "img/reaction1.c315366e.png";